"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TranslationProvider = exports.useTranslation = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const getTranslations_1 = __importDefault(require("../../../utils/getTranslations"));
const fallbackTranslateContext = {
    translate: (key) => key,
};
const TranslationContext = react_1.default.createContext(fallbackTranslateContext);
const useTranslation = () => {
    const context = react_1.default.useContext(TranslationContext);
    if (!context) {
        throw new Error('TranslationContext must be used with TranslationProvider');
    }
    return context;
};
exports.useTranslation = useTranslation;
const TranslationProvider = ({ children, locale = 'en-US', }) => {
    const [translations, setTranslations] = (0, react_1.useState)({});
    (0, react_1.useEffect)(() => {
        (0, getTranslations_1.default)(locale).then((result) => {
            setTranslations(result);
        });
    }, [locale]);
    const translate = (id) => {
        const translation = translations[id];
        if (!translation) {
            return '';
        }
        return translation;
    };
    return ((0, jsx_runtime_1.jsx)(TranslationContext.Provider, { value: { translate }, children: children }));
};
exports.TranslationProvider = TranslationProvider;
//# sourceMappingURL=TranslationProvider.js.map